export const environment = {
    ENV: 'ALPHA',
    SIGN: 'https://alpha.gateway.genos.ciera.com.br/genos-iam/api/v1',
    USER: 'https://alpha.gateway.genos.ciera.com.br/genos-iam/api/v1',
    IAM: 'https://alpha.gateway.genos.ciera.com.br/genos-iam/api/v1',
    HEALTH_ANALYSIS: 'https://alpha.gateway.genos.ciera.com.br/genos-health/api/v1',
    DELIVERY: 'https://alpha.gateway.genos.ciera.com.br/genos-delivery/api/v1',
    REPORT: 'https://alpha.gateway.genos.ciera.com.br/genos-report/api/v1',
    WORKFLOW: 'https://alpha.gateway.genos.ciera.com.br/genos-health/api/v1',
    AI: 'https://alpha.gateway.genos.ciera.com.br/genos-ai/api/v1',
    NOTIFICATION: 'https://alpha.gateway.genos.ciera.com.br/genos-notification/api/v1',
    PARTNER: 'https://alpha.gateway.genos.ciera.com.br/genos-partner/api/v1',
    SELF_ONBOARDING: 'https://alpha.gateway.genos.ciera.com.br/ciera-selfonboarding/api/v1',
    GATEWAY: 'https://alpha.gateway.genos.ciera.com.br',
    PRO: 'https://alpha.pro.ciera.com.br'
};
